const clean = value => String(value || "").trim();

export const QA_FIXTURE_CONTRIBUTOR_ID = "qa-phase8-fixture";
export const QA_FIXTURE_CONTRIBUTOR_PROFILE = Object.freeze({
  nombre: "QA Fixture",
  username: "qa-phase8",
  email: "",
});

export const maskContributorEmail = value => {
  const email = clean(value).toLowerCase();
  const at = email.indexOf("@");
  if (at <= 0 || at === email.length - 1) return null;
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  return `${local.slice(0, 1)}***@${domain}`;
};

export const contributorIdentity = profile => {
  const nombre = clean(profile?.nombre);
  const username = clean(profile?.username);
  const maskedEmail = maskContributorEmail(profile?.email);

  if (nombre) {
    return {
      primary: nombre,
      secondary: username && username.toLowerCase() !== nombre.toLowerCase() ? `@${username}` : null,
      source: "name",
    };
  }
  if (username) return { primary: username, secondary: null, source: "username" };
  if (maskedEmail) return { primary: maskedEmail, secondary: null, source: "email" };
  return { primary: "Usuario sin nombre", secondary: null, source: "fallback" };
};

export const buildAdminContributorProfiles = users => ({
  ...Object.fromEntries(
    (Array.isArray(users) ? users : [])
      .filter(user => clean(user?.id))
      .map(user => [user.id, { nombre: clean(user.nombre), username: clean(user.username), email: clean(user.email) }])
  ),
  [QA_FIXTURE_CONTRIBUTOR_ID]: QA_FIXTURE_CONTRIBUTOR_PROFILE,
});
